import {useState } from "react";
import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";







export default function BookSlider() {
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]); // <- also fixed: watch slides.length

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://notesmania.in/api/theme_setting/BannerSetting.php");
        const result = await response.json();

        const baseURL = "https://notesmania.in/api/theme_setting/";

        const mappedSlides = result.data.map(item => ({
          id: item.id,
          title: item.title,
          heading: item.heading,
          subheading: item.subheading,
          cta: item.cta,
          link: item.link,
          image: baseURL + item.bgImageURL,
          bgImage: baseURL + item.bookImageURL,
        }));

        setSlides(mappedSlides);
      } catch (error) {
        console.error("Error fetching or processing data:", error);
      }
    };

    fetchData();
  }, []);

  // 👉 Wait for slides to load
  if (slides.length === 0) {
    return null; // or a spinner
  }

  const current = slides[index];

  return (
    <div className="relative h-full  overflow-hidden ">
      <AnimatePresence mode="wait">
        <motion.div
          key={`bg-${current.id}`}
          className="absolute inset-0 z-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${current.bgImage})` }}
          initial={{ opacity: 0, scale: 1.05 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 1.05 }}
          transition={{ duration: 1 }}
        />
      </AnimatePresence>

      <div className="relative z-10 bg-black bg-opacity-50 h-full py-[10px] flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <AnimatePresence mode="wait">
              <motion.div
                key={`text-${current.id}`}
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -100 }}
                transition={{ duration: 0.8 }}
                className="text-white text-center lg:text-left"
              >
                <p className="text-base font-medium text-white/80">{current.title}</p>
                <h1 className="mt-4 text-white/100 font-bold text-center lg:text-left">
  {current.heading}
</h1>


                <div className="mt-10">
                  <p className="text-base text-white/80  font-bold">{current.subheading}</p>
                  <form className="mt-4">
                  
                  <button
  type="button"
  onClick={() => window.open(`https://${current.link}`)}
  className="mt-3 w-full lg:w-auto px-6 py-3 bg-gray-900 text-white font-bold rounded-md hover:bg-gray-700 transition"
>
  {current.cta}
</button>


                  </form>
                </div>
              </motion.div>
            </AnimatePresence>

            <AnimatePresence mode="wait">
              <motion.div
                key={`img-${current.id}`}
                initial={{ opacity: 0, y: 50, scale: 0.95 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -50, scale: 0.95 }}
                transition={{ duration: 0.8 }}
                className="relative flex justify-center"
              >
                <img
  src={current.image}
  alt="Book"
  className="
    w-48 h-64              // Mobile view
    sm:w-56 sm:h-72        // Small screens
    md:w-64 md:h-80        // Medium screens
    lg:w-72 lg:h-96        // Large screens (PC)
    xl:w-80 xl:h-[28rem]   // Extra-large screens
    drop-shadow-lg
    object-contain
"
/>

              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
}
